import * as React from "react";
import { useAsyncDebounce } from "react-table";
import * as SC from "./styles";

export default function GlobalSearchBox({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value.toLowerCase() || undefined);
  }, 200);

  React.useEffect(() => {
    if (!globalFilter) {
      setValue("");
    }
  }, [globalFilter]);

  return (
    <SC.SearchBoxWrapper>
      <SC.SearchInput
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={`Sök i tabellen (${count} rader)`}
      />
    </SC.SearchBoxWrapper>
  );
}
